// @ts-nocheck
import { createUrlWithSourceQueryParams } from 'Jsx/Analytics/Amplitude';

import { FREE_COURSES_AMPLITUDE_PAGE_NAME } from './constants';

export const ENROLLMENT_URL_SOURCES = {
  COURSE_AGENDA: 'Course Agenda',
  FREE_COURSE: 'Active Free Course',
} as const;

export type CourseDetailEnrollmentUrlSources =
  typeof ENROLLMENT_URL_SOURCES[keyof typeof ENROLLMENT_URL_SOURCES];

export const enrollmentUrlWithSourceDetail = {
  SOURCES: ENROLLMENT_URL_SOURCES,
  getUrl: ({
    originalId,
    enrollmentUrl,
    sourceDetail,
  }: {
    originalId?: number | null;
    enrollmentUrl?: string | null;
    sourceDetail: CourseDetailEnrollmentUrlSources;
  }) => {
    const url = enrollmentUrl || `/enrollment/${originalId}/`;

    return createUrlWithSourceQueryParams({
      url,
      source: FREE_COURSES_AMPLITUDE_PAGE_NAME,
      sourceDetail,
    });
  },
};

export const enrollToCourse = (enrollmentUrl: string) => {
  window.location.href = enrollmentUrl;
};
